var _circle, _path, _circle2, _circle3, _circle4, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgQuit02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#F6F4FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m74.638 73.276.895-.447-.895.447zm-2.397-8.41.854.52-.854-.52zm-.21 3.195-.895.447.895-.447zM36 55c0 11.046 8.954 20 20 20v-2c-9.941 0-18-8.059-18-18h-2zm20-20c-11.046 0-20 8.954-20 20h2c0-9.941 8.059-18 18-18v-2zm20 20c0-11.046-8.954-20-20-20v2c9.941 0 18 8.059 18 18h2zm-2.905 10.385A19.91 19.91 0 0 0 76 55h-2a17.91 17.91 0 0 1-2.613 9.346l1.708 1.04zm-1.959 3.123 2.608 5.216 1.789-.895-2.608-5.215-1.789.894zm2.608 5.216A.5.5 0 0 1 74.19 73v2a1.5 1.5 0 0 0 1.342-2.17l-1.79.894zM74.19 73H56v2h18.191v-2zm-2.804-8.654c-.741 1.218-.937 2.79-.251 4.162l1.789-.894c-.331-.663-.27-1.504.17-2.229l-1.708-1.04z",
    fill: "#BE69C3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 55,
    r: 2,
    fill: "#BE69C3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 55,
    r: 2,
    fill: "#BE69C3"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 55,
    r: 2,
    fill: "#BE69C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.744 36.133c-.669.079-1.327.192-1.972.34C51.582 29.946 45.87 25 39 25c-7.732 0-14 6.268-14 14 0 2.533.672 4.907 1.846 6.955.698 1.216.905 2.778.218 4.153L25.618 53h12.486A19.234 19.234 0 0 0 38 55H24.809a1.5 1.5 0 0 1-1.342-2.17l.895.446-.895-.447 1.808-3.615c.33-.66.27-1.507-.163-2.264A15.931 15.931 0 0 1 23 39c0-8.837 7.163-16 16-16 7.858 0 14.392 5.664 15.744 13.133z",
    fill: "#BE69C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgQuit02);
export default __webpack_public_path__ + "static/media/img_quit_02.48c095dacd5d993e84a48895998a49f9.svg";
export { ForwardRef as ReactComponent };